<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <rabbitGroomingBanner-component />
    <footer-component />
  </div>
</template>
<script>
import headerComponent from '../header/headerComponent.vue';
import rabbitGroomingBannerComponent from '../rabbitGrooming/rabbitGroomingBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'bookingComponent',
  components: {
    headerComponent,
    rabbitGroomingBannerComponent,
    footerComponent,
  },
};
</script>
